export default __webpack_public_path__ + "static/2-24f6f14e4c72d9836a665bef576b2f3d.png";